import { render, staticRenderFns } from "./WorkPackCreatorContainer.vue?vue&type=template&id=77b92c95&"
import script from "./WorkPackCreatorContainer.vue?vue&type=script&lang=js&"
export * from "./WorkPackCreatorContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77b92c95')) {
      api.createRecord('77b92c95', component.options)
    } else {
      api.reload('77b92c95', component.options)
    }
    module.hot.accept("./WorkPackCreatorContainer.vue?vue&type=template&id=77b92c95&", function () {
      api.rerender('77b92c95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/workPacks/components/components/WorkPackCreatorContainer.vue"
export default component.exports